import React from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import LineCheckIcon from 'components/Luxkit/Icons/line/LineCheckIcon'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Group from 'components/utils/Group'

const StepCircleWrapper = styled(Group)`
  width: ${rem(24)};
  height: ${rem(24)};
  background-color: ${props => props.theme.palette.neutral.default.one};
  border-radius: 100%;

  &.border-pending {
    background-color: unset;
    border: 1px solid ${(props) => props.theme.palette.neutral.default.four};
  }

  &.border-complete {
    background-color: unset;
    border: 1px solid ${(props) => props.theme.palette.neutral.default.one};
  }
`

interface Props {
  status: 'active' | 'pending' | 'complete'
  text: string
}

function BusinessTravellerStepCircle(props: Props) {
  const { status, text } = props
  const className = `border-${status}`
  const fontColour = status === 'active' ? 'neutral-eight' : status === 'pending' ? 'neutral-four' : 'neutral-one'

  return <StepCircleWrapper direction="horizontal" horizontalAlign="center" verticalAlign="center" className={className}>
    {status === 'complete' && <LineCheckIcon colour="neutral-one" size={16} />}
    {(status === 'pending' || status === 'active') && <BodyText variant="small" colour={fontColour}>{text}</BodyText>}
  </StepCircleWrapper>
}

export default BusinessTravellerStepCircle
